<template>
  <b-container class="create-program-container">
    <b-row>
      <b-col md="8">
        <b-row>
          <b-col md="12">
            <h2 class="float-left">{{ isEdit ? 'Program szerkesztése' : 'Új program hozzáadása' }}</h2>
          </b-col>
        </b-row>
        <b-row class="first-row">
          <b-col md="7"
            ><b-form-group id="program-name">
              <legend>Cím</legend>
              <b-form-input
                id="program-name"
                placeholder="Mezőgazdasági program..."
                v-model="name"
                type="text"
                class="border inputFieldAlign"
              >
              </b-form-input>
              <input-error :v-if="nameError.length > 0" :errors="[nameError]" />
            </b-form-group>
          </b-col>
          <b-col md="5"
            ><b-form-group id="program-code">
              <legend>Kód(Opcionális)</legend>
              <b-form-input
                id="program-code"
                placeholder="GINOP 1.2.1..."
                v-model="code"
                type="text"
                class="border inputFieldAlign"
              >
              </b-form-input>
              <input-error :v-if="codeError.length > 0" :errors="[codeError]" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12 mb-3">
            <label class="float-left">Státusz jelző</label
            ><b-dropdown :text="readableStatus(status)" class="dropdown-competition height40px"
              ><b-dropdown-item
                @click="changeStatus(programStatus.REGISTRATION_OPEN)"
                :value="programStatus.REGISTRATION_OPEN"
                >{{ readableStatus(programStatus.REGISTRATION_OPEN) }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="changeStatus(programStatus.REGISTRATION_CLOSED)"
                :value="programStatus.REGISTRATION_CLOSED"
                >{{ readableStatus(programStatus.REGISTRATION_CLOSED) }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="changeStatus(programStatus.PREQUALIFICATION_CLOSED)"
                :value="programStatus.PREQUALIFICATION_CLOSED"
                >{{ readableStatus(programStatus.PREQUALIFICATION_CLOSED) }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="changeStatus(programStatus.PREQUALIFICATION_OPEN)"
                :value="programStatus.PREQUALIFICATION_OPEN"
                >{{ readableStatus(programStatus.PREQUALIFICATION_OPEN) }}</b-dropdown-item
              >
              <b-dropdown-item @click="changeStatus(undefined)" :value="undefined">Üres</b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="9">
            <b-form-group id="program-link">
              <legend>Link</legend>
              <b-form-input
                id="program-link"
                placeholder="http://vali.hu"
                v-model="link"
                type="text"
                class="border inputFieldAlign"
              >
              </b-form-input>
              <input-error :v-if="linkError.length > 0" :errors="[linkError]" />
            </b-form-group>
          </b-col>
          <b-col md="3 mt-3">
            <b-form-group>
              <b-form-checkbox
                id="blank_checkbox"
                v-model="openLinkInBlank"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
                class="mt-3"
              >
                Külső link
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-button @click="save" variant="primary" class="save-button">Mentés</b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="4">
        <program-card :name="name" :code="code" :link="link" :status="status" color="green" />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ProgramCard from './components/ProgramCard'
import { createProgram, editProgram, getProgram } from '../../api/program'
import { PROGRAM_STATUS, getReadableProgramStatus } from './models/programStatus'
import InputError from '../../components/InputError.vue'
export default {
  name: 'CreateProgram',
  components: { InputError, ProgramCard },
  data: function() {
    return {
      name: '',
      code: '',
      status: undefined,
      link: '',
      openLinkInBlank: false,
      nameError: '',
      codeError: '',
      statusError: '',
      linkError: '',
      programStatus: PROGRAM_STATUS
    }
  },
  created: async function() {
    if (this.isEdit) {
      const program = await getProgram(this.$route.query.id)
      this.name = program.name
      this.code = program.code
      this.status = program.status
      this.link = program.link
      this.openLinkInBlank = program.openLinkInBlank
    }
  },
  computed: {
    isEdit: function() {
      return !!this.$route.query.id
    }
  },
  methods: {
    getStatusColor: function(status) {
      switch (status) {
        case PROGRAM_STATUS.REGISTRATION_OPEN:
          return 'green'
        case PROGRAM_STATUS.REGISTRATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_OPEN:
          return 'green'
      }
    },
    readableStatus: function(status) {
      return getReadableProgramStatus(status)
    },
    changeStatus: function(status) {
      this.status = status
    },
    clearErrors: function() {
      this.codeError = ''
      this.nameError = ''
      this.linkError = ''
    },
    resetValues: function() {
      this.code = ''
      this.name = ''
      this.link = ''
      this.status = ''
    },
    save: async function() {
      try {
        this.clearErrors()
        const data = {
          name: this.name,
          link: this.link,
          code: this.code,
          status: this.status,
          openLinkInBlank: this.openLinkInBlank
        }
        if (this.isEdit) {
          await editProgram(data, this.$route.query.id)
        } else {
          await createProgram(data)
          this.resetValues()
          this.$router.push('/contents/programs')
        }
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'success',
            message: this.isEdit ? 'Program módosítása sikeres!' : 'Program feltöltése sikeres!'
          }
        })
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data && e.response.data.details) {
          const errors = e.response.data.details
          errors.forEach(error => {
            if (error.path.includes('code')) {
              this.codeError = error.message
            }
            if (error.path.includes('name')) {
              this.nameError = error.message
            }
            if (error.path.includes('link')) {
              this.linkError = error.message
            }
          })
        } else throw e
      }
    }
  }
}
</script>
<style scoped>
.float-left {
  float: left;
}
.form-group legend {
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
  padding-left: 10px;
}
.save-button {
  width: 100% !important;
}
.create-program-container {
  position: relative;
}
.preview-container {
  position: absolute;
  top: 0px;
  right: 0px;
  min-height: 365px;
  width: 500px;
}
</style>
